module.exports = __webpack_public_path__ + "img/logo.5c7c0097.svg";